import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { InspectionService } from '../shared/services/inspection.service';
import { DataTableDirective } from 'angular-datatables';
import {ApplicationView } from '../../models/ApplicationModel';
import { AccountService } from '../../services/account.service';
import * as Constants from '../../models/Constants';
import { CommonService } from '../../shared/services/common.service';
import { AssignAppToUser, Assignee, ProductType } from '../../models/CommonModels';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { UserDto } from '../../models/User';
import { UserService } from '../../services/user.service';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from '../../shared/services/alert.service';
import { ApplicationService } from '../../shared/services/application.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-pre-inspection-app-list',
  templateUrl: './pre-inspection-app-list.component.html',
  styleUrls: ['./pre-inspection-app-list.component.css']
})
export class PreInspectionAppListComponent implements OnInit {

  @ViewChild('assignForm') assignForm: NgForm;
  @ViewChild(DataTableDirective, { static: true })
  datatableElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  applications: ApplicationView[] = [];
  selectedApplication: ApplicationView; 
  productTypes: ProductType[] = [];

  datepicker: Date;
  minDate: Date;
  bsValue: Date = new Date();
  bsConfig: Partial<BsDatepickerConfig>;

  inspectors: UserDto[] = [];
  filteredPrimaryInspectors: UserDto[] = [];
  filteredNonPrimaryInspectors: UserDto[] = [];
  modalRef: BsModalRef;
  
  assignedUser: UserDto = null;
  previousPrimaryInspector: UserDto = null;
  assignedInspectorIDs: Array<number> = [];
  dropDownItems = [];
  selectedDropDownItem = "ALL";

  constructor(private inspectionService: InspectionService, private accountService: AccountService, private commonService: CommonService,
    private userService: UserService, private modalService: BsModalService, private spinner: NgxSpinnerService, 
    private alertService: AlertService, private applicationService: ApplicationService, private errorHandlerService: ErrorHandlerService) { 

      const colorTheme = 'theme-green';
      this.minDate = new Date();
      this.minDate.setDate(this.minDate.getDate());
      this.bsConfig = Object.assign({}, {dateInputFormat: 'MMMM Do YYYY', containerClass: colorTheme });
    }

  ngOnInit() {
    this.dropDownItems = [ 
      {code : "ALL", name: "All"}, 
      {code : "QUC", name: "Quarantine Candidates"},  
      {code : "QUA", name: "Quarantined Applications"}];
    this.dtOptions = this.inspectionService.getPreInspectionDataTableOptions(this.applications);
    this.commonService.getProductTypes().subscribe(productTypes => this.productTypes = productTypes);
    if(this.isUserInspectionTeamLeader()){
      this.userService.getInspectors(this.accountService.getUserBranchOffice().id).subscribe(resp => {
        this.inspectors = resp;
        this.inspectors.map( (user) => { user.fullName = user.firstName + ' ' + user.lastName; return user; } );
      });
    }

  }

  isUserInspectionTeamLeader(): boolean {
    return this.accountService.isUserInspectionTeamLeader();
  }

  isUserDirector(): boolean {
    return this.accountService.isUserDirector();
  }

  getStatusColor(status) {
    return Constants.COLOR_MAP[status];
  }

  showReturnToCsoButton(app){
    if ((app.applicationCategoryName === Constants.APPLICATION_TYPE_NAME_CHANGE || app.applicationCategoryName === Constants.APPLICATION_TYPE_NAME_TEMP_CHANGE) 
       && app.flowTypeName == Constants.APPLICATION_FLOW_TYPE_NAME_MINOR) {
      return false;
    } else {
      return this.accountService.isUserInspectionTeamLeader() &&
        (app.applicationStatusCode === Constants.PRESCREENED_CODE ||
          app.applicationStatusCode === Constants.RETURN_TO_INSPECTOR_TEAM_LEADER_CODE);
    }
  }

  isAssigningInspectors (app) {
    let statusCode = app.applicationStatusCode;
    return (([Constants.PRESCREENED_CODE, Constants.PAYMENT_VERIFIED_CODE, Constants.PAYMENT_CONFIRMED_CODE, Constants.RETURN_TO_INSPECTOR_CODE,
      Constants.RETURN_TO_INSPECTOR_TEAM_LEADER_CODE, Constants.INSPECTOR_ASSIGNED_CODE,Constants.FI_SUBMITTED, 
      Constants.INFO_FOR_INSPECTION_REQUESTED, Constants.INFO_FOR_INSPECTION_SUBMITTED, Constants.FI_SUBMITTED_AFTER_INSPECTION].indexOf(statusCode) !== -1));
  }

  /*means only one inspector is assigned*/
  isAssigningScreenerInspector(){
    return this.selectedApplication.applicationCategoryName === Constants.APPLICATION_TYPE_NAME_RENEWAL && 
       this.selectedApplication.facilityCategoryName !== Constants.FACILITY_CAT_RED;
  }

  getDateString(createdDate) {
    if (!createdDate) {
      return '';
    }
    let date = new Date(createdDate);
    return date.toLocaleDateString('en-US', {year : 'numeric', month: 'short', day: 'numeric'});
  }

  showAssignUserModal(applicationId, template: TemplateRef < any > ) {
    this.datepicker = null;
    this.assignedInspectorIDs = [];
    this.assignedUser = null;
    this.selectedApplication = this.applications.find(a => a.id === applicationId);
    const appDeptCode = this.getApplicationDepartment();

    this.filteredPrimaryInspectors = this.inspectors.filter(u => (u.departments.map(
        	  p => p.code).indexOf(appDeptCode) !== -1));

    this.filteredNonPrimaryInspectors = this.filteredPrimaryInspectors.slice(0);

    this.previousPrimaryInspector = null;

    this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false});
  }

  getApplicationDepartment() {
    let applicationProductTypeName  = this.productTypes.find(p => p.name.trim() === this.selectedApplication.productType.trim()).name;
    if (applicationProductTypeName === Constants.PRODUCT_TYPE_FOOD) {
      return Constants.FOOD_DEPARTMENT;
    } else if (applicationProductTypeName === Constants.PRODUCT_TYPE_TOBACCO) {
      return Constants.TOBACCO_DEPARTMENT;
    } else {
      return Constants.MED_DEPARTMENT;
    }
  }

  primaryInspectorChanged() {
    let index = this.filteredNonPrimaryInspectors.findIndex(u => u.id === this.assignedUser.id);
    this.filteredNonPrimaryInspectors.splice(index, 1);
    if (this.previousPrimaryInspector != null) {
      this.filteredNonPrimaryInspectors.push(this.previousPrimaryInspector);
    }
    this.filteredNonPrimaryInspectors = this.filteredNonPrimaryInspectors.slice(0); // ng-select only listens to changes if it is a new array

    this.filteredNonPrimaryInspectors.sort( (a, b) => {
      let name1 = a.fullName.toUpperCase();
      let name2 = b.fullName.toUpperCase();
      if (name1 < name2) {
        return -1;
      }
      if (name1 > name2) {
        return 1;
      }
      return 0;
    });

    this.previousPrimaryInspector = this.assignedUser;
    let primaryIndex = this.assignedInspectorIDs.findIndex(id => id === this.assignedUser.id);
    if (primaryIndex !== -1) {
      this.assignedInspectorIDs.splice(primaryIndex, 1);
      this.assignedInspectorIDs = this.assignedInspectorIDs.slice(0); // ng-select only listens to changes if it is a new array
    }
  }

  assignApplicationToUser() {
    let assignees: Assignee[] = [];
    assignees.push(new Assignee(this.assignedUser.id, true));
    this.assignedInspectorIDs.forEach(id => {
      assignees.push(new Assignee(id, false));
    });    
    let assignToUserData: AssignAppToUser = new AssignAppToUser( this.selectedApplication.id, assignees, this.datepicker.toISOString());

    this.spinner.show();

    this.applicationService.assignApplicationToUser(assignToUserData).subscribe(
      resp => {
        console.log('res ', resp);
        this.spinner.hide();
        if (resp) {
          this.selectedApplication.assignedUser = this.assignedUser.fullName;
          this.selectedApplication.assignedUserID = this.assignedUser.id;
          this.selectedApplication.dueDate = assignToUserData.dueDate;
          if (this.selectedApplication.applicationStatusCode === Constants.REQUESTED_CODE) {
            this.selectedApplication.applicationStatusName = Constants.CSO_ASSIGNED_MESSAGE;
            this.selectedApplication.applicationStatusCode = Constants.CSO_ASSIGNED_CODE;
          } else if ( [Constants.PAYMENT_VERIFIED_CODE, Constants.RETURN_TO_INSPECTOR_TEAM_LEADER_CODE,
            Constants.PAYMENT_CONFIRMED_CODE
          ]
            .indexOf(this.selectedApplication.applicationStatusCode) !== -1) {
            this.selectedApplication.applicationStatusName = Constants.INSPECTOR_ASSIGNED_MESSAGE;
            this.selectedApplication.applicationStatusCode = Constants.INSPECTOR_ASSIGNED_CODE;
          }
          this.alertService.success('Application Assigned to user successfully');
        } else {
          this.alertService.error('Unable to assign application, please try again later.');
        }

        this.modalRef.hide();
      },
      error => {
        this.spinner.hide();
        let errorMsg = this.errorHandlerService.handleApiError(error);
        this.alertService.error(errorMsg + ' , please try again');
        this.modalRef.hide();
      },
      () => {
        this.datepicker = null;
        this.assignedInspectorIDs = [];
        this.assignedUser = null;
      }
    );
  }

  dropDownChanged(){
     if(this.selectedDropDownItem == "QUC"){
      this.inspectionService.tobeQuarantinedFilter = true;
      this.inspectionService.preInspectionAppStatus = null;
    } else if(this.selectedDropDownItem == "QUA"){
      this.inspectionService.preInspectionAppStatus = Constants.QUARANTINED;
      this.inspectionService.tobeQuarantinedFilter = false; 
    } else {
      this.inspectionService.preInspectionAppStatus = null;
      this.inspectionService.tobeQuarantinedFilter = false; 
    }
    
    this.reloadList();
  }

  reloadList() {
    if (this.datatableElement.dtInstance) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.draw();
      });
    }
  }
}
